import type { CarouselControlDirection } from './types';

export const getAriaLabelFromDirection = (direction?: CarouselControlDirection) => {
  switch (direction) {
    case 'right':
      return 'Следующий слайд';
    case 'left':
    default:
      return 'Предыдущий слайд';
  }
};
